import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from 'cn';
import { Slot } from 'radix-ui';
/*
 * ДОБАВЛЕН `asChild` - БЕЗ ЕДИНОГО ИЗМЕНЕНИЯ ВИДА.
 *
 * Карточке продукта нужен осмысленный тег: форма входа - это `form`,
 * карточка списка - `section`. В поставке Card всегда `div`. Приём тот же,
 * которым пользуется сам shadcn в остальных примитивах (Slot из базовой
 * библиотеки), поэтому обновление компонента CLI его не потеряет по смыслу.
 * Ни один класс и ни один токен при этом не тронут.
 */
function Card({ className, size = 'default', asChild = false, ...props }) {
    const Comp = asChild ? Slot.Root : 'div';
    return (_jsx(Comp, { "data-slot": "card", "data-size": size, className: cn('group/card flex flex-col gap-(--card-spacing) overflow-hidden rounded-xl bg-card py-(--card-spacing) text-sm text-card-foreground ring-1 ring-foreground/10 [--card-spacing:--spacing(4)] has-data-[slot=card-footer]:pb-0 has-[>img:first-child]:pt-0 data-[size=sm]:[--card-spacing:--spacing(3)] data-[size=sm]:has-data-[slot=card-footer]:pb-0 *:[img:first-child]:rounded-t-xl *:[img:last-child]:rounded-b-xl', className), ...props }));
}
function CardHeader({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-header", className: cn('group/card-header @container/card-header grid auto-rows-min items-start gap-1 rounded-t-xl px-(--card-spacing) has-data-[slot=card-action]:grid-cols-[1fr_auto] has-data-[slot=card-description]:grid-rows-[auto_auto] [.border-b]:pb-(--card-spacing)', className), ...props }));
}
/* `asChild` - чтобы заголовок карточки был настоящим заголовком (h2/h3), а
   не `div`. Причина и приём те же, что у Card выше; вид не меняется. */
function CardTitle({ className, asChild = false, ...props }) {
    const Comp = asChild ? Slot.Root : 'div';
    return (_jsx(Comp, { "data-slot": "card-title", className: cn('font-heading text-base leading-snug font-medium group-data-[size=sm]/card:text-sm', className), ...props }));
}
function CardDescription({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-description", className: cn('text-sm text-muted-foreground', className), ...props }));
}
function CardAction({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-action", className: cn('col-start-2 row-span-2 row-start-1 self-start justify-self-end', className), ...props }));
}
function CardContent({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-content", className: cn('px-(--card-spacing)', className), ...props }));
}
function CardFooter({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-footer", className: cn('flex items-center rounded-b-xl border-t bg-muted/50 p-(--card-spacing)', className), ...props }));
}
export { Card, CardHeader, CardFooter, CardTitle, CardAction, CardDescription, CardContent };
//# sourceMappingURL=card.js.map